module.exports = __webpack_public_path__ + "img/首图.73127d53.png";